import { Logger } from './Logger';
import { formatMessage } from './logHelpers';

/**
 * `Logger` implementation that writes to the browser console.
 */
export class ConsoleLogger implements Logger {
    async initialize(): Promise<void> {
        // kept for future implementations, e.g., if we want to use
        // async stuff like indexedDB
    }

    info(message: string, tag?: string) {
        console.log(formatMessage(message, tag));
    }

    debug(message: string, tag?: string) {
        console.debug(formatMessage(message, tag));
    }

    error(message: string, tag?: string) {
        console.error(formatMessage(message, tag));
    }

    warn(message: string, tag?: string) {
        console.warn(formatMessage(message, tag));
    }
}
